import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface IDeleteElementState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const DeleteElementEmptyState: IDeleteElementState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
